import { motion } from 'framer-motion';
import { Home, Users, Shield, Headphones } from 'lucide-react';
import { useLang } from '@/context/LanguageContext';

const icons = [Home, Users, Shield, Headphones];

const ResidencyExperienceSection = () => {
  const { t, translations, lang } = useLang();
  const features = translations.experience.features;

  return (
    <section id="experience" data-testid="experience-section" className="py-24 md:py-32 bg-[#3D2020]">
      <div className="px-5 md:px-10 lg:px-14 max-w-7xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="max-w-3xl mb-20"
        >
          <p className="text-[11px] uppercase tracking-[0.3em] text-white/50 mb-4">
            {t('experience.label')}
          </p>
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-white leading-tight mb-6 whitespace-pre-line">
            {t('experience.title')}
          </h2>
          <p className="text-base text-white/70 leading-relaxed">
            {t('experience.desc')}
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12">
          {features.map((f, i) => {
            const Icon = icons[i];
            return (
              <motion.div
                key={i}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: i * 0.1 }}
                className="flex gap-5"
              >
                <div className="flex-shrink-0 w-11 h-11 rounded-lg bg-[#E92A3E]/15 flex items-center justify-center">
                  <Icon className="text-[#E92A3E]" size={20} />
                </div>
                <div>
                  <h3 className="font-heading font-bold text-base text-white mb-2">
                    {f.title[lang]}
                  </h3>
                  <p className="text-sm text-white/60 leading-relaxed">
                    {f.desc[lang]}
                  </p>
                </div>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default ResidencyExperienceSection;
